export const REQUEST_GALLERY_FETCH_EM = "REQUEST_GALLERY_FETCH_EM"
export const FETCH_GALLERY_EM_SUCCESS = "FETCH_GALLERY_EM_SUCCESS"
export const FETCH_GALLERY_EM_FAILURE = "FETCH_GALLERY_EM_FAILURE"

export const CLEAR_FETCH_GALLERY_EM_STATES = "CLEAR_FETCH_GALLERY_EM_STATES"